import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CModal } from "@/components";
import { useResumeFile } from "@/store/useResumeFile";
import { Button, message } from "antd";
import { useState } from "react";
import styles from "./index.module.less";
import { deleteResume } from "@/services/attachmentManager";
import { WarningFilledIcon } from "@bossvn/icons";
import { useLocale } from "@/hooks/useLocale";
import { withErrorBoundary } from "../ErrorBoundary/hoc";
const DeleteModal = withErrorBoundary(({ isDeleteModalOpen, setDeleteModalOpen, currentResume, handleResumeDeleteSuccess, locale }) => {
    const [loading, setLoading] = useState(false); // 提交loading
    const getResumeList = useResumeFile((state) => state.getResumeList);
    const { t } = useLocale("attachmentManager", locale);
    // 删除简历
    const handleRename = async () => {
        setLoading(true);
        try {
            const response = await deleteResume(currentResume?.fileGroupId || '');
            if (response.code === 0) {
                message.success(t('deleteSucceed'));
                // 如果删除的是对外展示简历-需要展开切换弹窗
                if (currentResume?.isOpen === 1) {
                    handleResumeDeleteSuccess && handleResumeDeleteSuccess('delete');
                }
                else {
                    getResumeList();
                }
                setDeleteModalOpen(false);
            }
            else {
                message.error(t('deleteFailed'));
            }
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx(CModal, { open: isDeleteModalOpen, width: 501, closable: false, centered: true, title: _jsxs("div", { className: styles.deleteModal_header, children: [_jsx(WarningFilledIcon, { size: 20, primaryColor: "#FF9500" }), _jsx("div", { className: styles.renameModal_title, children: t('confirmDelete') })] }), showCancel: false, footer: _jsxs("div", { className: styles.renameModal_footer, children: [_jsx(Button, { className: styles.deleteModal_footer_ok, color: "danger", variant: "solid", loading: loading, onClick: handleRename, children: t("delete") }), _jsx("div", { className: styles.renameModal_footer_cancel, onClick: () => setDeleteModalOpen(false), children: t("cancel") })] }), children: _jsx("div", { className: styles.deleteModal_text, children: t('confirmDeleteText') }) }));
});
export default DeleteModal;
DeleteModal.displayName = "DeleteModal";
